import { FC } from "react";
import { Command } from "@vendor/cmdk/cmdk";
import { TRANSACTION_REVIEW_FIELD_LABELS } from "@common/types/transactionFieldReview";
import { pluralizeWithCount } from "@common/helpers/string";
import { CommandItem } from "@design-system/CommandItem/CommandItem";
import { useReviewableFields } from "@hooks/useReviewableFields";
import { CommandsListProps } from "./lib";
import { useCommands } from "./useCommands";

interface Props extends CommandsListProps {
    mode: "markReviewed" | "unreview";
}

export const TransactionBulkReviewFieldCommandsList: FC<Props> = ({
    options = {},
    mode,
}) => {
    const { returnToRoot } = useCommands();
    const {
        selectedTransactionCount = 0,
        onTransactionBulkMarkReviewedForFields,
        onTransactionBulkUnreviewForFields,
    } = options;

    const onSelect =
        mode === "markReviewed"
            ? onTransactionBulkMarkReviewedForFields
            : onTransactionBulkUnreviewForFields;

    const heading = `${mode === "markReviewed" ? "Mark as reviewed" : "Unreview"} — ${pluralizeWithCount("transaction", selectedTransactionCount)} selected`;

    const allFields = useReviewableFields();

    return (
        <Command.Group heading={heading}>
            <CommandItem
                keywords={["all", "every field"]}
                onSelect={() => {
                    onSelect?.(allFields);
                    returnToRoot();
                }}
            >
                All fields
            </CommandItem>
            {allFields.map((field) => (
                <CommandItem
                    key={field}
                    keywords={[field, TRANSACTION_REVIEW_FIELD_LABELS[field]]}
                    onSelect={() => {
                        onSelect?.([field]);
                        returnToRoot();
                    }}
                >
                    {TRANSACTION_REVIEW_FIELD_LABELS[field]}
                </CommandItem>
            ))}
        </Command.Group>
    );
};
